module.exports = __webpack_public_path__ + "paypal.d03230046c8ad26d86913d662f62613d.svg";